import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var ChallanListRes;
export const ChallanListTodo = createAsyncThunk('ChallanList', async (data) => {
    // console.log("data", data)
    const type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'dashboard_challan_list',
            data: {
                "vfrom_date": data?.fromDate,
                "vto_date": data?.toDate,
                "vchallan_code": data?.search,
                "vfin_year": localStorage.getItem('vfin_year'),
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id'),
                "invoice_type": "-1",
                "cstatus": "1",
                "com_status": "O"
            },
            headers: { "Content-Type": "application/json" },

        })
        return ChallanListRes = res.data

    } catch (error) {
        return ChallanListRes = error.response.data
    }
});

const ChallanListSlice = createSlice({
    name: 'ChallanList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(ChallanListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(ChallanListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default ChallanListSlice.reducer; 